export const en = {
    document_add: 'Add document',
    empty_description: 'They are needed to buy tickets and book hotels',
    empty_title: 'Add documents',
    expires_date: 'Expires after {date}',
    expired_message: 'Expired',
    document_type: 'Document type',
    confirm_remove_title: 'Delete document?',
};
